import { commitAction } from '../actions/commit'
import { commitMutation } from '../mutations/commit'

export const commit = {
  state: {
    'pass/change': {
      isPosting: false,
      data: {},
      msg: ''
    }
  },
  mutations: commitMutation,
  actions: commitAction
}
